import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { useFormStep } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/hooks/useFormStep";
import type { IFormStepContextValue } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";
import { CompetitorsSection } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/components/competitor-section/CompetitorsSection";

export const LLMSetupFormStep3 = () => {
    const {
        stepData: { competitors, domains, isLoadingCompetitors, generatedCompetitorsError },
        stepHandlers: { handleCompetitorChange, handleCompetitorDelete },
        stepErrors,
        showStepErrors,
    } = useFormStep() as IFormStepContextValue;

    const competitorErrorsByIndex = useMemo<Record<number, { domain?: string; brand?: string }>>(() => {
        if (!showStepErrors) {
            return {};
        }
        const result: Record<number, { domain?: string; brand?: string }> = {};
        stepErrors.forEach((err) => {
            if (err.index === undefined) {
                return;
            }
            if (err.field === "competitor.domain") {
                result[err.index] = { ...result[err.index], domain: err.message };
            } else if (err.field === "competitor.brand") {
                result[err.index] = { ...result[err.index], brand: err.message };
            }
        });
        return result;
    }, [stepErrors, showStepErrors]);

    return (
        <CompetitorsSection
            title={translate("llm.setup.competitors.title")}
            competitors={competitors}
            trackedDomains={domains}
            isLoading={isLoadingCompetitors}
            onCompetitorChange={handleCompetitorChange}
            onCompetitorDelete={handleCompetitorDelete}
            hasGenerationError={!!generatedCompetitorsError}
            errorsByIndex={competitorErrorsByIndex}
        />
    );
};
